
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * DayOfWeek enum
 */
class DayOfWeek {
  /**
   * Initialize enum with a given value
   * @param {DayOfWeek|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof DayOfWeek) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!DayOfWeek}
   * @param {!DayOfWeek} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof DayOfWeek)) {
      throw new TypeError('Instance of DayOfWeek is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!DayOfWeek}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!DayOfWeek}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === DayOfWeek.SUNDAY.value) {
      return 'SUNDAY'
    }
    if (this.value === DayOfWeek.MONDAY.value) {
      return 'MONDAY'
    }
    if (this.value === DayOfWeek.TUESDAY.value) {
      return 'TUESDAY'
    }
    if (this.value === DayOfWeek.WEDNESDAY.value) {
      return 'WEDNESDAY'
    }
    if (this.value === DayOfWeek.THURSDAY.value) {
      return 'THURSDAY'
    }
    if (this.value === DayOfWeek.FRIDAY.value) {
      return 'FRIDAY'
    }
    if (this.value === DayOfWeek.SATURDAY.value) {
      return 'SATURDAY'
    }
    if (this.value === DayOfWeek.NONE.value) {
      return 'NONE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!DayOfWeek}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!DayOfWeek}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!DayOfWeek} Created enum
   */
  static fromObject (other) {
    return new DayOfWeek(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
DayOfWeek.SUNDAY = new DayOfWeek(0 + 0)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.MONDAY = new DayOfWeek(0 + 1)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.TUESDAY = new DayOfWeek(0 + 2)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.WEDNESDAY = new DayOfWeek(0 + 3)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.THURSDAY = new DayOfWeek(0 + 4)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.FRIDAY = new DayOfWeek(0 + 5)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.SATURDAY = new DayOfWeek(0 + 6)
// noinspection PointlessArithmeticExpressionJS
DayOfWeek.NONE = new DayOfWeek(0 + 7)

export { DayOfWeek };

/**
 * Fast Binary Encoding DayOfWeek field model
 */
class FieldModelDayOfWeek extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelDayOfWeek}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelDayOfWeek}
   * @param {DayOfWeek=} defaults Default value, defaults is new DayOfWeek()
   * @returns {!DayOfWeek} Result value
   */
  get (defaults = new DayOfWeek()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new DayOfWeek(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelDayOfWeek}
   * @param {!DayOfWeek} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelDayOfWeek };
